export default __webpack_public_path__ + "static/media/cheque-icon.8da4da3b.svg";